import { createClient } from "@sanity/client";

export const clientCMSRH = createClient({
  projectId: "3g6cptqu",
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: "2024-01-01",
  useCdn: false,
});
